<script setup>
import { ref, computed } from 'vue'
import Icon from '@/components/shell/Icon.vue'
import { store } from '@/store/appStore.js'
const typeFilter = ref('All')
const TYPE_ICON = { Order:'clipboard', Stock:'boxes', Invoice:'file' }
const CHANNEL_ICON = { Push:'bell', SMS:'phone', Email:'file' }
const notifications = computed(() => {
  const list = typeFilter.value==='All' ? store.data.notifications.value : store.data.notifications.value.filter(n=>n.type===typeFilter.value)
  return [...list].sort((a,b)=>b.timestamp.localeCompare(a.timestamp))
})

// Phase 10: interactive deep linking. Routes to the Order Tracking drawer,
// Stock Dashboard (search-filtered), or Invoice & Billing drawer. Only
// clickable when the destination module is actually in the current role's
// visible modules — e.g. a Sales Executive has no Order Tracking access, so
// an Order notification stays informational (non-clickable) for that role
// rather than routing to a screen they can't see.
const DEEP_LINK_MODULE = { Order: 'orderTracking', Invoice: 'invoiceBilling', Stock: 'stockDashboard' }
function canDeepLink(n) {
  const modId = DEEP_LINK_MODULE[n.type]
  return !!modId && store.visibleModules.value.some(m => m.id === modId)
}
function openNotification(n) {
  if (!canDeepLink(n)) return
  const modId = DEEP_LINK_MODULE[n.type]
  if (n.type === 'Stock') store.setPendingFocus({ type: 'stock', id: n.relatedEntityId, query: n.relatedEntityId })
  else if (n.type === 'Invoice') store.setPendingFocus({ type: 'invoice', id: n.relatedEntityId })
  else store.setPendingFocus({ type: 'order', id: n.relatedEntityId })
  store.setActiveModule(modId)
}
</script>
<template>
  <div>
    <div class="card module-header"><span class="eyebrow">Module 16 — Notification Engine</span><h2>{{ notifications.length }} notifications in this scenario</h2><p class="muted">Click a linkable notification to jump straight to the record</p></div>
    <div class="card">
      <div class="toolbar">
        <select class="filter-select" v-model="typeFilter"><option>All</option><option>Order</option><option>Stock</option><option>Invoice</option></select>
        <span class="result-count">{{ notifications.length }} shown</span>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>Type</th><th>Message</th><th>Channel</th><th>Timestamp</th></tr></thead>
          <tbody>
            <tr v-for="n in notifications" :key="n.id" :class="{ clickable: canDeepLink(n) }" @click="openNotification(n)">
              <td><span style="display:inline-flex;align-items:center;gap:6px;"><Icon :name="TYPE_ICON[n.type]||'bell'" :size="14" />{{ n.type }}</span></td>
              <td>{{ n.message }} <span v-if="canDeepLink(n)" class="cell-muted" style="font-size:11px;">→</span></td>
              <td class="cell-muted"><span style="display:inline-flex;align-items:center;gap:6px;"><Icon :name="CHANNEL_ICON[n.channel]||'bell'" :size="13" />{{ n.channel }}</span></td>
              <td class="cell-muted">{{ n.timestamp }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>